<template>
  <div class="p-1">
   <div class="h-20 py-3 flex items-center border-black-200 p-6 mt-5">
        <div class="flex w-full">
          <button
            :class="$colors.primary"
            class="rounded-full flex justify-center items-center w-8 h-8 mr-3"
            @click="RouterBack()"
          >
            <i class="material-icons">chevron_left</i>
          </button>

          <div class="text-xl font-bold text-black-600">Details</div>
        </div>
      </div>
    <div-table
      :config="configList"
      :data="content"
      :idWharhouse="idWharhouse"
      :currentUser="currentUser"
      :loading="loading"
      :paginate="paginate"
      @paginatation="paginatation"
      @downloadStocks="downloadStocks"
    ></div-table>
  </div>
</template>
 
<script>
import config from "./configStock";
export default {
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object}
   },
  data() {
    return {
      configList: config.list,
      loading: false,
      content: [],
      currentProduct: {},
      limit: 100,
      stocks:[],
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 1,
        per_page: 0,
      },
    };
  },
  computed: {
    warhouseSelected(){
          return this.$store.getters["wharhouse/warhouseSelected"]({user:_.pick(this.currentUser,['warehouses'])});
      },
  }, 
  watch: { 
      'warhouseSelected': async function(oldVal, newVal) {
          //  await this.getwharhouseId();
          //  await this.getStockHistories({ limit: this.limit });
      },
      'idWharhouse': async function(oldVal, newVal) {
           this.idWharhouse=oldVal;  
           await this.getStockHistories({ limit: this.limit });
        }
  },
  async mounted() {
      //await this.getUser();
      if(this.currentUser && this.currentUser.type=="Seller"){
         let userI = this.configList.columns.map(function (e) {return e.name;}).indexOf('User');
         if(userI!=-1)  this.configList.columns.splice(userI, 1);  
        //  let pos = this.configList.columns.map(function (e) {return e.name;}).indexOf('Wharhouse name');
        //  if(pos!=-1)  this.configList.columns.splice(pos, 1);  
      }
     // await this.getwharhouseId();
      await this.getProduct();
      await this.getStockHistories({ limit: this.limit });
      
      
  },
  methods: {
    async getwharhouseId(){
       await this.$store.dispatch('wharhouse/getwharhouseId',{country: this.warhouseSelected,}).then((res) => {this.idWharhouse=res;})
    }, 
    RouterBack: function() {
      this.$router.back();
    },
      async downloadStocks(){
        this.loading = true;
        await this.getAllStockHistories({ limit: 90000 });
       this.loading = false;
        var arr = typeof this.stocks !== 'object' ? JSON.parse(this.stocks) : this.stocks;
        for (let i in arr) {
              arr[i].Product=this.currentProduct.name;
              arr[i].Quantity=arr[i].status=='in'?'+'+arr[i].quantity:'-'+arr[i].quantity;
              arr[i].Type=arr[i].type;
              arr[i].Date =this.$moment(arr[i].date).format("yyyy-MM-DD HH:mm");
              arr[i].Reason=arr[i].reason;
        }
        for (let j in arr) {
              delete arr[j].code;
              delete arr[j].product;
              delete arr[j].isDeleted;
              delete arr[j].date;
              delete arr[j].order;
              delete arr[j].quantity;
              delete arr[j].type;
              delete arr[j].reason;
              delete arr[j].expedition;
              delete arr[j].shipping;
              delete arr[j].status;
              delete arr[j].user;
              delete arr[j].__v;
               delete arr[j]._id;
              delete arr[j].vat;
          }
        let str =
          `${Object.keys(arr[0])
            .map((value) => `"${value}"`)
            .join(',')}` + '\r\n';
        let csvContent = arr.reduce((st, next) => {
          st +=
            `${Object.values(next)
              .map((value) => `"${value}"`)
              .join(',')}` + '\r\n';
          return st;
        }, str);
        let element = document.createElement('a');
        element.href = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(csvContent);
        element.target = '_blank';
        element.download = 'stocks.csv';
        element.click();
    },
    async getUser() {
      const res = await this.$me;
      this.currentUser = res.content;
    },
    async getProduct() {
       const product = await this.$server.get("products", {id: this.$route.params.id,});
       this.currentProduct=product.content;
    },
    async getAllStockHistories(filters){
      filters.product= this.$route.params.id;
      filters.warehouse= this.idWharhouse._id;
      filters.country= this.idWharhouse.country;
       const res = await this.$server.search("stockHistories", filters);
       if (res.content.results) {
        this.stocks = res.content.results;
      } else this.stocks = [];
    },
    async getStockHistories(filters) {

        filters.product= this.$route.params.id;
        filters.warehouse= this.idWharhouse._id;
        filters.country= this.idWharhouse.country;
       // filters.type="InStockTotal";
      this.loading = true;
      const res = await this.$server.search("stockHistories", filters);
       this.loading = false;
     /* if (res.content.results) {
        this.content = res.content.results;
        let stockHistories = this.content;
        for (let i in stockHistories) {
          stockHistories[i].user = stockHistories[i].user.email;
          stockHistories[i].date = stockHistories[i].date.split("T")[0];
          stockHistories[i].product = stockHistories[i].product.name;
          stockHistories[i].quantity = stockHistories[i].quantity;
          stockHistories[i].reason = stockHistories[i].reason;
        }

        this.content = stockHistories;
        console.log("hiiiii", stockHistories);
      } else this.content = []*/

       if (res.content.results) {
        this.content = res.content.results;
        for (let i in this.content) {
          this.content[i].product = this.currentProduct;
          this.content[i].name_warehouse=this.content[i].warehouse.name;
        }
        
        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
      } else this.content = [];
    },

    async refresh() {
      this.getStockHistories({ limit: this.limit });
    },

     async paginatation(direction) {
      var page = 0;
      if (direction == "next") {
        page = ++this.paginate.currentpage;
      } else {
        page = --this.paginate.currentpage;
      }
      const filters = {
        page: page,
        limit: this.limit,
      };
      this.getStockHistories(filters);
    },
  },
};
</script>


